

















import * as Gdpr from '@/model';
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import Article from '@/components/Article.vue';

@Component({
  components: {
    Article,
  },
})
export default class Section extends Vue {
  @Prop({ default: {} }) private data!: Gdpr.Section;
  @Prop({ default: false }) private interactive!: boolean;

  @Emit('article-click')
  private fireArticleClick(article: Gdpr.Article): Gdpr.Article {
    return article;
  }

  private get h1(): string {
    return Gdpr.HtmlEncode(this.data.h1);
  }

  private get h2(): string {
    return Gdpr.HtmlEncode(this.data.h2);
  }
}
